export default __webpack_public_path__ + "static/media/The_times_of_india.576cee2c.webp";